import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import BannerSlider from "./Home/BannerSlider";
import { dynamicBanner, dynamicBannerBroker } from "../redux/Cart/actions";
import Slider from "react-slick";
import moment from "moment";
import { SessionKeys } from "../utils/AppUtils";
import _ from "lodash";
import ContentLoader from 'react-content-loader'
import ShimmerScreen from "./Layouts/ShimmerScreen";
import { clickStreamUser } from "../utils/AppUtils";
import { useNavigate } from "react-router-dom";
const BannerSection = () => {
  const navigate = useNavigate();
  const dynamicBannerInfo = useSelector((state) => state.carts.dynamicBanner);
  const dispatch = useDispatch();
  const [bannerData, setBannerData] = useState({});
  const [bannerBrokerData, setBannerBrokerData] = useState({});
  const userRole = useSelector((state) => state.user.role);
  const [isLoading, setIsLoading] = useState(false)
  const auth = useSelector((state) => state.auth.auth);
  const authBroker = useSelector(state => state.auth.authBroker)

  // console.log("User rolesss", userRole);
  const redirectToSignUp = () => {
    clickStreamUser("clicked-login-btn", {
      is_guest_user: true,
      session_id: localStorage.getItem("sessionId"),
    });
    navigate("/sign-up?p=1");
  };
  useEffect(() => {
    dispatch(
      dynamicBanner({
        ecom: {
          module: "splash-banner",
          broker: false,
          postData: { "get-banner": true, token: localStorage.getItem(SessionKeys.API_TOKEN_BROKER) },
          // postData: { "get-banner": true, },  //token: localStorage.getItem(SessionKeys.API_TOKEN_BROKER)
        },
        broker: {
          module: "splash-banner",
          broker: true,
          postData: {
            token: localStorage.getItem(SessionKeys.API_TOKEN_BROKER),
          },
        },
      })
    );
    // setIsLoading(true)
  }, [dispatch]);

  useEffect(() => {
    // console.log("merge data", dynamicBannerInfo);
    if (_.isArray(dynamicBannerInfo)) {
      let bannerArray = [];
      for (let banner of dynamicBannerInfo) {
        if (banner.status === "success") {
          let bannerData = _.isArray(banner.payload.data)
            ? banner.payload.data
            : [];
          bannerArray = [...bannerData, ...bannerArray];
        }
      }
      setIsLoading(false)
      setBannerData(bannerArray);
    }
  }, [dynamicBannerInfo]);

  const settings = {
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: true,
    dots: true,
    arrows: false,
    autoplaySpeed: 5000,
    infinite: true,
  };

  return (
    <>
      {userRole === "instructor" || userRole === "host" ? (
        ""
      ) : (
        <div className="bannermodule">
        <Slider {...settings}>
          {bannerData.length > 0 ? (
            bannerData.map((m, index) => {
              return (
                <section className="container-fluid p-0" key={index}>
                  <div className="row">
                    <section className="baner-section home_page_bannner">
                      <div className="row m-0">
                        <div className=" p-0 carousel_slide">
                          <div
                            id="carouselExampleIndicators"
                            className="carousel slide"
                            data-bs-ride="carousel"
                          >
                            <div className="carousel-inner">
                              <div className="carousel-item active dynamic-banner">
                                <img
                                  src={m.thumbnail}  
                                  className="d-block w-100"
                                  alt="..."
                                />
                                <div className="provider-slider-inner">
                                  <div className="container">
                                    {localStorage.getItem(SessionKeys.API_TOKEN_BROKER)?(
                                    <div className="banner-text-provider text-white">
                                      {m?.banner_title_visibility === "1" && <h2 className="mainHEADING">
                                        {m.banner_title}
                                      </h2>}
                                      
                                      <div className=" d-flex py-3">
                                        <a
                                          href={m.button_url}
                                          target="_blank"
                                          rel="noopener noreferrer"
                                        >
                                          {m.button_text === undefined || _.isEmpty(m.button_text) ? "" : <button
                                            type="button"
                                            className="startcourse-btn"
                                            onClick={() => {
                                              clickStreamUser("more-info-button-clicked", {
                                                url: m.button_url,
                                                userId: authBroker?.payload?.user.user_id,
                                              });
                                            }
                                            }
                                          >
                                            {m.button_text}
                                            <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none"><path d="M4.16602 9.99981H15.8327M15.8327 9.99981L9.99935 4.16648M15.8327 9.99981L9.99935 15.8331" stroke="#6941C6" strokeWidth="1.66667" stroke-linecap="round" stroke-linejoin="round"></path></svg>
                                          </button>}
                                        </a>
                                      </div>
                                    </div>
                                    ): ""
                                    //  <div className="banner-text-guest">
                                    //   <h2 className="mainHEADING">
                                    //     Welcome to Xsel - Your Gateway to Real Estate Excellence!
                                    //   </h2>
                                    //   <p className="banner-subtext">
                                    //       Xsel isn’t just a learning platform—it's an innovative, AI-powered tool designed to transform your real estate career. Whether you’re a seasoned agent or just starting out, Xsel provides the resources and support you need to thrive in today’s competitive market. Join thousands of agents who have already made Xsel their go-to platform for professional development.</p>
                                    //   <div className=" d-flex py-3">
                                    //   <button
                                    //     className="subscriptionbtn"
                                    //     onClick={() => redirectToSignUp()}
                                    //   >
                                    //     Get your free subscription
                                    //   </button>
                                        
                                    //   </div>
                                    // </div>
                                    
                                  }
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </section>
                  </div>
                </section>
              );
            })
          ) : (
            <>
              {/* <div className="nobannerimage"></div>
              <div className="container">
                <p
                  className="my-cart-texts"
                  style={{ fontSize: "18px", fontFamily: "Inter" }}
                ></p>
              </div> */}
              {
                isLoading ?
                  <div className="nobannerimage ">
                    <ShimmerScreen
                      case={'rect'}
                      width={'100%'}
                      height={'100%'}
                    />
                  </div> :
                  <div className="nobannerimage loading-stop">
                    <p
                      className="my-cart-texts"
                      style={{ fontSize: "18px", fontFamily: "Inter" }}
                    ></p>
                  </div>
              }
            </>
          )}
        </Slider>
        </div>
      )}
    </>
  );
};
export default BannerSection;
